export default __webpack_public_path__ + "static/media/icon-Beneficio03.7643212f.svg";